import { parseResContent, aggregateBiomarkers, pickKeyFindings } from "@/lib/resParser";
import { buildAnalysisSummary } from "@/lib/analysisSummary";
import { loadAnalysis } from "@/lib/persistence";

function mapFindings(findings) {
  return findings.map((f) => ({
    title: f.title,
    value: f.value || "",
    direction: f.direction || "unknown",
  }));
}

function collectAlgorithmCodes(algorithmResult = {}) {
  return Object.values(algorithmResult)
    .filter((a) => a?.SUCCESS && a?.response)
    .map((a) => a.response);
}

export function buildAnalysisEmailPayload(result, locale = "es") {
  if (!result) return null;

  const parsed = parseResContent(result.resContent || "");
  const aggregate = aggregateBiomarkers(parsed.biomarkers || []);
  const keyFindings = pickKeyFindings(parsed, result.algorithmResult, 3);
  const summary = buildAnalysisSummary({ parsed, result, lang: locale });
  const findingsForApi = mapFindings(keyFindings);
  const savedAt = loadAnalysis()?.savedAt || new Date().toISOString();
  const origin = typeof window !== "undefined" ? window.location.origin : "";

  return {
    present: true,
    labName: result.labName || undefined,
    originalFileName: result.originalFileName || undefined,
    savedAt,
    patientName: parsed.patient?.fullName || undefined,
    analysisSummaryText: summary?.text || undefined,
    resultUrl: origin ? `${origin}/result` : undefined,
    keyFindings: findingsForApi,
    snapshot: {
      biomarkersTotal: aggregate.total,
      biomarkersInRange: aggregate.normal,
      biomarkersAltered: aggregate.altered,
      algorithmCodes: collectAlgorithmCodes(result.algorithmResult),
      keyFindings: findingsForApi,
    },
  };
}
